import React, { Component } from "react";
import { UPLOAD_PATH } from "constant.js";

import * as ajax from "helpers/ajax";
import * as myFunctions from "helpers/functions";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"
import Modal from '@mui/material/Modal';

import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import defaultUser from 'assets/images/default-user.png';
import { toPrice, calculateMarkup } from "helpers/functions.js"



export default class DataTableModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            generalError: "",

            modalOpen: false,
            editMode: null,
            loading:false,
        };
        this.inputRefs = {}
    }

    openModal = (open, data = {}, editMode = null) => {
        if (!open) {
            this.setState({ data: {}, modalOpen: false, editMode: null })
            return
        }
        this.setState({ data: data, oldData: { ...data }, modalOpen: true, editMode: editMode })
    }

    checkAddress = (string, name) => {
        ajax.getPositionFromAddress(string,this.checkAddressCallback, name)
    }

    checkAddressCallback = (response, key) => {
        if (response.results.length <= 0) {
            this.setChanges(null, "longitudine");
            this.setChanges(null, "latitudine");
            let errors = this.state.errors
            errors[key]=true
            this.setState({errors:errors});
            return;
        }

        this.setChanges(response.results[0].geometry.location.lng, "longitudine_" + key);
        this.setChanges(response.results[0].geometry.location.lat, "latitudine_"+key);
        this.setChanges(response.results[0].formatted_address, key);
    }

    createInput = (el, index) => {
        if (el.showFunctionID) {
            switch (el.showFunctionID) {
                case 1: if (this.state.data.user_type == "Dipendenti") { if (this.state.data["consulente"]) { this.setChanges(null, "consulente") }; return this.createSelectRef(el, index) } else {return null };
                case 2: if (this.state.data.user_type == "Consulenti") { if (this.state.data["dipendente"]) { this.setChanges(null, "dipendente") }; return this.createSelectRef(el, index) } else { return null};
                default: return null;
            }
        }

        switch  (el.type){
            case "text": return this.createInputText(el, index);
            case "textarea": return this.createInputText(el, index);
            case "maps": return this.createInputText(el, index);
            case "date": return this.createInputText(el, index);
            case "time": return this.createInputText(el, index);
            case "email": return this.createInputText(el, index);
            case "select": return this.createSelect(el, index);
            case "checkbox": return this.createCheckBox(el, index);
            case "avatar": return this.createAvatar(el, index);
            case "hidden": return this.createHiddenInput(el, index);
            case "number": return this.createInputText(el, index)
            case "ref": return this.createSelectRef(el, index)
            case "function": return this.createInputFunction(el, index)
            case "customSelect": return this.createCustomInput(el,index)
            default: return null;
        }
    }

    createInputText = (el, index) => {
        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <MDInput
                    multiline={(el.type == "textarea") ? true : false}
                    rows={(el.type == "textarea") ? 5 : 1}
                    error={this.state.errors[el.name]}
                    label={el.label}
                    type={el.type}
                    value={this.state.data[el.name] ? this.state.data[el.name] : ""}
                    fullWidth
                    required={(el.required) ? true : false}
                    disabled={el.disabled && this.state.editMode ? true : false}
                    onChange={(e) => { this.setChanges(e.target.value, el.name) }}
                    onBlur={(e) => {
                        if (el.type == "maps") {
                            this.checkAddress(e.target.value, el.name)
                        }
                    }}
                    step="1"
                    InputLabelProps={(el.type == "date" || el.type == "time") ? { shrink: true } : null}
                />
            </Grid>
        );
    }



    createInputFunction = (el, index) => {
        var fn = Function("return "+el.functionName+"()");

        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <MDInput
                    label={el.label}
                    disabled
                    value={fn()}
                    fullWidth
                    required={(el.required) ? true : false}
                />
            </Grid>
        );
    }

    createSelect = (el, index) => {
        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <MDInput error={this.state.errors[el.name]}
                    error={this.state.errors[el.name]}
                    value={this.state.data[el.name] ? this.state.data[el.name] : ""}
                    select
                    fullWidth
                    label={el.label}
                    required={(el.required) ? true : false}
                    onChange={(e) => this.setChanges(e.target.value, el.name)}
                >
                    {el.values.map((val, i) => {
                        return (
                            <MenuItem value={val} key={"select-" + el.label + "-" + i}>{val}</MenuItem>
                        )
                    })}
                </MDInput>
            </Grid>
        );
    }

    createSelectRef = (el, index) => {

        if (!this.props.tableData.fields[index].values) { return null }
        let id = "";
        if (this.state.data[el.name]) {
            if (this.state.data[el.name].id) {
                id = this.state.data[el.name].id
            } else {
                id = this.state.data[el.name]
            }
        }
        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <MDInput error={this.state.errors[el.name]}
                    error={this.state.errors[el.name]}
                    value={id}
                    select
                    fullWidth
                    label={el.label}
                    required={(el.required) ? true : false}
                    onChange={(e) => this.setChanges(e.target.value, el.name)}
                >
                    {el.values.map((val, i) => {
                        return (
                            <MenuItem value={val.id} key={"select-" + el.label + "-" + i}>
                                {val[el.refColLabel]}
                                {el.refColLabel2 ? " " + val[el.refColLabel2] : ""}
                            </MenuItem>
                        )
                    })}
                </MDInput>
            </Grid>
        );
    }

    createCheckBox = (el, index) => {
        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <FormControlLabel
                    control={<Switch checked={this.state.data[el.name] ? this.state.data[el.name] : false} onChange= {(e) => this.setChanges(e.target.checked, el.name)} /> }
                    label={<MDTypography variant="button">{el.label}</MDTypography>}
                />
            </Grid>
            );
    }

    createAvatar = (el, index) => {
        return (
            <Grid item xs={el.xs ? el.xs : 12} sm={el.sm ? el.sm : 12} md={el.md ? el.md : 12} my={1} px={1} key={index}>
                <input accept=".png, .jpg, .jpeg" onChange={(file)=>this.handleImageChange(file.target.files, el.path, el.name)} id={el.name+index}  type={"file"} required={(el.required) ? true : false} style={{ visibility: "hidden", position:"absolute" }} />
                <label htmlFor={el.name + index} style={{cursor:"pointer", display:"flex", alignItems:"center",justifyContent:"center"}}>
                    <MDAvatar src={this.avatarUrl(el)} shadow={"lg"} alt="Avatar" size="xxl" >
                        <img style={{ width: "100%", height: "100%" }} src={defaultUser} /> 
                    </MDAvatar>
                </label>
            </Grid>
        )
    }

    avatarUrl = (el) => {
        if (this.state.editMode && !this.state.data["avatar"]) {
            return UPLOAD_PATH + "/file/" + el['path'] + "/" + this.state.data['id'] + ".png?" + Date.now()
        }
        return (this.state.data.avatar ?.url) ? this.state.data.avatar.url : defaultUser
    }


    createHiddenInput = (el, index) => {
        let data = this.state.data;
        if (el.value) {
            switch (el.value) {
                case "randomString": data[el.name] = myFunctions.randomString(20); break;
                case "commessaID": data[el.name] = this.props.commessaID; break;
                case "hiddenID": data[el.name] = this.props.hiddenID; break;
                default: data[el.name] = el.value
            }
        }
        if (data == this.state.data) {return}//avoid recursion rerendering
        this.setState({ data: data });
    }


    handleImageChange = (file, path, name) => {
        let data = this.state.data;
        const objectUrl = URL.createObjectURL(file[0])
        data[name] = {};
        data[name]["url"] = objectUrl;
        data[name]["file"] = file[0];
        data[name]["path"] = path;
        this.setState({ data: data })
    }

    setChanges = (val, name) => {
        let data = this.state.data;
        data[name] = val;

        let errors = this.state.errors;
        errors[name] = false;
        this.setState({ data: data, errors:errors, generalError:"" })
    }

    checkRequired = () => {
        let errors = this.state.errors
        let valid = true;
        this.props.tableData.fields.map((el, index) => {
            if (el.required) {
                if (!this.state.data[el.name]) {
                    errors[el.name] = true;
                    valid=false
                }
            }
        })
        this.setState({ error: errors })
        return valid;
    }


     timeout=(delay)=> {
        return new Promise(res => setTimeout(res, delay));
    }

    containAddress = () => {
        let temp = false;
        this.props.tableData.fields.map((el) => {
            if (el.type == "maps") { temp = true;}
        })
        return temp;
    }
    saveData = async () => {
        //wait for maps, maybe we need a better solution
        if (this.state.loading) { return }

        if (this.props.onBeforeEdit) {
            if (!this.props.onBeforeEdit(this.state.data, this.state.oldData)) {
                this.setState({ loading: false })
                return;
            }
        }

        if (this.containAddress()) {
            this.setState({loading:true})
            await this.timeout(1000);
        }

        if (!this.checkRequired()) {
            this.setState({ loading: false })
            return;
        }

        let data = {}


        //console.log(this.state.data)
        this.props.tableData.fields.map((el, index) => {
            if (el.type == "avatar") { return }
            if (el.type == "checkbox" && typeof this.state.data[el.name] != "boolean") { return data[el.name] = false }
            data[el.name] = this.state.data[el.name]

            if (el.type == "time") {
                data[el.name] = this.state.data[el.name] + ":00"
            }

            if (this.state.editMode && el["edit"] == false) {
                delete data[el.name]; 
            }
        })

        let formData = { "data": data };
        if (this.props.tableData.noDataWrapper) {
            formData = data;
        }


        if (this.state.editMode) {
            ajax.ajaxPutStrapi(this.props.tableData.route + "/" + this.state.data["id"], formData, this.saveDataCallback)
        } else {
            ajax.ajaxPostStrapi(this.props.tableData.route, formData, this.saveDataCallback)
            if (this.props.newRawData) {
                this.props.newRawData(data)
            }
        }
    }

    saveDataCallback = (response) => {
        this.setState({ loading: false })
        if (response.error) {
            let errors = this.state.errors
            if (response.error.details.errors) {
                if (response.error.details.errors.length > 0) {
                    response.error.details.errors.map((el) => {
                        errors[el.path[0]] = true
                    })
                    this.setState({ errors: errors })
                }
            }

            this.setState({ generalError: this.translateError(response.error.message) })
        } else {
            if (this.state.data["avatar"]) {
                if (this.state.data["avatar"]["file"]) {
                    let formData = new FormData();
                    formData.append("path", this.state.data["avatar"]["path"]);
                    formData.append("name", this.props.tableData.noDataWrapper ? response.id : response.data.id);
                    formData.append("file", this.state.data["avatar"]["file"]);
                    ajax.ajaxUploadImage(formData, this.saveComplete);
                } else {
                    this.saveComplete(response)
                }
            } else {
                this.saveComplete(response)
            }
        }
    }

    saveComplete = (response = null) => {
        if (this.state.editMode && this.props.onEdit) {
            this.props.onEdit(response, this.state.oldData);
        }

        if (!this.state.editMode && this.props.onNew) {
            this.props.onNew(response);
        }

        this.props.successCallback((this.state.editMode) ? this.props.tableData.editedLabel : this.props.tableData.addedLabel)
        this.openModal(false);


    }

    translateError = (msg) => {
        switch (msg) {
            case "username must be at least 3 characters": return "Il Nome Utente deve essere di almeno 3 caratteri";
            case "Email already taken": return "Email gia' in uso";
            case "ruolo must be defined.": return "Seleionare un ruolo";
            case "email must be a valid email": return "Email non valida";
            default: return "Compilare tutti i dati richiesti";
        }
    }


    render() {
        return (
            <Modal
                open={this.state.modalOpen}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow:"scroll" }}
                onClose={() => this.openModal(false)}
                style={{
                    maxWidth: 700, margin: "auto", display: "flex", alignItems: "center", overflow: "scroll"
                }}
            >
                <MDBox
                    bgColor={"white"}
                    borderRadius="lg" 
                    p={2}
                    minWidth={400}
                >
                    <MDBox
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        mx={2}
                        mt={-3}
                        p={2}
                        mb={1}
                        textAlign="center"
                    >
                        <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                            {this.state.editMode ? this.props.tableData.editLabel : this.props.tableData.addLabel}
                        </MDTypography>
                    </MDBox>

                    <Grid container={true}>
                        {this.props.tableData.fields.map((el, index) => {
                            return this.createInput(el, index)
                            })}
                    </Grid>


                    {(this.state.generalError != "") ?
                        <Grid item sm={12}>
                            <MDAlert color={"error"} dismissible>
                                    {this.state.generalError}
                            </MDAlert>
                        </Grid>
                        : null
                    }
                    <MDButton disabled={this.state.loading} fullWidth color="success" onClick={() => this.saveData()}>
                        <Icon style={{ marginRight: 10 }}>add</Icon>
                        Salva {this.props.tableData.addLabel}
                    </MDButton>
                </MDBox>

            </Modal>
        )
    }
}

DataTableModal.defaultProps = {
    tableData: {},
}


